import React from 'react';
import { cx } from '../../../../../ui/components/cx';
import './Switch.scss';

interface SwitchProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  label: React.ReactNode;
  description?: React.ReactNode;
  /** 'danger' when switching on blocks or removes something. */
  tone?: 'primary' | 'danger';
  disabled?: boolean;
  className?: string;
}

/** Labelled on/off toggle rendered as a full-width row (role="switch"). */
const Switch: React.FC<SwitchProps> = ({ checked, onChange, label, description, tone = 'primary', disabled, className }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    disabled={disabled}
    className={cx('tp-switch', `tp-switch--${tone}`, checked && 'tp-switch--on', className)}
    onClick={() => onChange(!checked)}
  >
    <span className="tp-switch__track" aria-hidden>
      <span className="tp-switch__thumb" />
    </span>
    <span className="tp-switch__text">
      <span className="tp-switch__label">{label}</span>
      {description && <span className="tp-switch__description">{description}</span>}
    </span>
  </button>
);

export default Switch;
